import { render, staticRenderFns } from "./TableCard.vue?vue&type=template&id=686cecb0&scoped=true&lang=pug&"
var script = {}
import style0 from "./TableCard.vue?vue&type=style&index=0&id=686cecb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686cecb0",
  null
  
)

export default component.exports